import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export function hiddenBaseSearchReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'is-in-hidden-base') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jsonQuery.unsetHiddenBaseSearch(),
          },
        };
      }

      return state;

    default:
      return state;
  }
}
